import { useQueryStates, parseAsIndex, parseAsInteger } from 'nuqs'

export const useVndlyCandidateIssuesPaginationQueryState = () => {
  const queryStates = useQueryStates(
    {
      pageIndex: parseAsIndex.withDefault(0),
      pageSize: parseAsInteger.withDefault(50),
    },
    {
      urlKeys: {
        pageIndex: 'candidate-page',
        pageSize: 'candidate-page-size',
      },
    }
  )

  return queryStates
}
